<script setup lang="ts">
import { useDisplay } from 'vuetify'
import { useStaffSettingsPane } from '../../composables/useStaffSettingsPane'

const { xs } = useDisplay()
const { width, startResize, isResizing } = useStaffSettingsPane({
  initial: 320,
  min: 260,
  max: () => Math.max(480, window.innerWidth - 420),
  storageKey: 'staff-settings-left',
})
</script>

<template>
  <VCard class="staff-settings-split d-flex flex-column overflow-hidden" rounded="lg">
    <slot name="header" />
    <div
      class="staff-settings-split__body d-flex flex-grow-1 overflow-hidden"
      :class="xs ? 'flex-column' : 'flex-row flex-nowrap'"
    >
      <div
        class="staff-settings-split__left overflow-y-auto pa-4"
        :class="{ 'staff-settings-split__left--stacked': xs }"
        :style="xs ? undefined : { width: `${width}px` }"
      >
        <slot name="left" />
      </div>
      <div
        v-if="!xs"
        class="entity-form-resizer"
        :class="{ 'is-resizing': isResizing }"
        @mousedown="startResize"
      />
      <div class="staff-settings-split__right d-flex flex-column flex-grow-1 overflow-hidden pa-4">
        <slot name="right" />
      </div>
    </div>
  </VCard>
</template>

<style scoped lang="scss">
.staff-settings-split {
  min-block-size: 560px;
  max-block-size: calc(100vh - 220px);
}

.staff-settings-split__body {
  min-block-size: 0;
}

.staff-settings-split__left {
  flex: 0 0 auto;
  min-inline-size: 0;
  overflow-x: hidden;
}

.staff-settings-split__left--stacked {
  width: 100%;
  flex: 1 1 240px;
  min-block-size: 240px;
}

.staff-settings-split__right {
  min-inline-size: 0;
  min-block-size: 240px;
}
</style>
